import { render, staticRenderFns } from "./mobile_bottom.vue?vue&type=template&id=4a1480b1&scoped=true"
import script from "./mobile_bottom.vue?vue&type=script&lang=js"
export * from "./mobile_bottom.vue?vue&type=script&lang=js"
import style0 from "./mobile_bottom.vue?vue&type=style&index=0&id=4a1480b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1480b1",
  null
  
)

export default component.exports